import React, { createContext, useContext, useState, useCallback } from "react";
import { Backdrop, CircularProgress, Typography } from "@mui/material";
import { AppTheme } from "../theme/App.theme";

// Create a context for the backdrop
const BackdropContext = createContext();

// Create a provider component for the backdrop
export const BackdropProvider = ({ children }) => {
  // State to manage the backdrop open state
  const [open, setOpen] = useState(false);

  // Function to show the backdrop
  const showBackdrop = useCallback(() => {
    setOpen(true);
  }, []);

  // Function to hide the backdrop
  const hideBackdrop = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <BackdropContext.Provider value={{ showBackdrop, hideBackdrop }}>
      {/* Render any children components wrapped by this provider */}
      {children}

      {/* Render the backdrop component */}
      <Backdrop
        sx={{ color: AppTheme.PRIMARY_WHITE, zIndex: (theme) => theme.zIndex.modal + 1 }}
        open={open}
      >
        <div className="d-flex align-items-center gap-3 justify-content-center">
          <Typography className="plus-jakarta-sans-medium-500" variant="h5">
            Please wait...
          </Typography>
          <CircularProgress
            size={45}
            style={{ color: AppTheme.PRIMARY_WHITE }}
            thickness={3}
          />
        </div>
      </Backdrop>
    </BackdropContext.Provider>
  );
};

// Custom hook to use the backdrop context
export const useBackdrop = () => {
  return useContext(BackdropContext);
};
